import InstitutionCard from "./InstitutionCard";
export default InstitutionCard